// generated from 3 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceRaidFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_raid_filter"),
  comparison_key: z.literal("1"),
  display_name: z.string(),
  value: z.literal("1"),
  varies_by_app_group: z.literal(false),
});
